import React from 'react';
import { CHECKOUT_URL, bonuses } from '../data/atlante';
export function BonusSection() {
  return <section className="border-y-4 border-gold bg-gold/10 px-4 py-5 sm:py-7" data-id="element-19" data-mp="1ogn8frff7v70">
      <div className="mx-auto max-w-5xl" data-id="element-20" data-mp="22fd6b9a2dywf">
        <h2 className="text-center text-xl leading-tight text-navy sm:text-2xl" data-id="element-21" data-mp="22ebw170vhgfr">
          🎁 4 BONUS PROFESSIONALI INCLUSI
        </h2>

        <div className="mt-3 grid gap-2.5 md:grid-cols-2" data-id="element-22" data-mp="1yc74cdtzitvr">
          {bonuses.map(bonus => <a key={bonus.num} href={CHECKOUT_URL} className="flex flex-col border border-gold/50 bg-white p-4 shadow-sm transition-colors duration-150 hover:border-navy" data-id="element-23" data-mp="1am2z6215em2n">
              <p className="font-display text-[11px] font-extrabold uppercase tracking-wide text-gold" data-id="element-24" data-mp="1epiv0w5e8iea">
                🎁 BONUS {bonus.num}
              </p>
              <h3 className="mt-0.5 text-[15px] leading-tight text-navy" data-id="element-25" data-mp="qydfyj7a1u51">
                {bonus.title}
              </h3>
              <p className="mt-0.5 text-[12.5px] font-bold leading-snug text-slate2" data-id="element-26" data-mp="29s30xa4thh92">
                {bonus.subtitle}
              </p>
              <p className="mt-1.5 text-[13px] font-medium leading-snug text-slate2" data-id="element-27" data-mp="2eq4ljzhw5omn">
                {bonus.body}
              </p>
              <p className="mt-1.5 text-[13px] font-medium leading-snug text-slate2" data-id="element-28" data-mp="2jio6jhiwrm1h">
                {bonus.body2}
              </p>
              <p className="mt-auto pt-2 font-display text-[13px] font-extrabold uppercase tracking-wide text-navy" data-id="element-29" data-mp="1qtgynrxkdk3k">
                {bonus.kicker}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}